<template>
  <el-row :gutter="10" align="middle" class="layer-item-wrapper">
    <el-col :span="14">
      <div class="layer-name">
        <el-text>
          {{ name }}
        </el-text>
      </div>
    </el-col>
    <el-col :span="10" class="align-right">
      <el-button link @click="toggleVisible" v-if="showToggleBtn">
        <el-icon v-if="layer.options.visible"><View /></el-icon>
        <el-icon v-else><Hide /></el-icon>
      </el-button>
      <el-button icon="Search" link @click="openSearch" v-if="showSearchBtn" />
      <el-button icon="Refresh" link @click="refresh" v-if="showRefreshBtn" />
    </el-col>
  </el-row>
</template>
<script>
export default {
  props: {
    layer: {
      type: Object,
      required: true,
    },
    visId: {
      type: String,
      required: true,
    },
    showToggleBtn: {
      type: Boolean,
      required: false,
      default: true,
    },
    showSearchBtn: {
      type: Boolean,
      required: false,
      default: true,
    },
    showRefreshBtn: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    name() {
      return (
        this.layer.options.name ||
        this.layer.options.table_name_alias ||
        this.layer.options.table_name ||
        this.layer.options.source
      );
    },
  },
  methods: {
    toggleVisible() {
      this.$store.dispatch("maps/toggleMapLayserVisible", {
        visId: this.visId,
        layerId: this.layer.id,
        visible: !this.layer.options.visible,
      });
      this.$emit("toggleVisible", this.layer, this.visible);
    },
    openSearch() {
      this.$emit("openSearch", this.layer);
    },
    refresh() {
      this.$emit("refresh", this.layer);
    },
  },
};
</script>
<style scoped>
.layer-item-wrapper {
  border-bottom: 1px solid  #ebeef5;
  margin: 6px 20px;
}

.layer-thumb-wrapper {
  text-align: left;
}

.layer-name {
  text-align: left;
}
</style>
